globalDefaults